import React, { useState } from "react";
import "./menuBar.css";
import LOGO_PNG from "../../../assets/images/logo.png";
import {
  ROOT,
  SERVICES_PATH,
  PRODUCTS_PATH,
  CONTACT_PATH,
  ABOUT_US_PATH,
} from "../../../router/Routes";
import { withRouter } from "react-router-dom";
import MENU_ICON_SVG from "../../../assets/icons/menu.svg";
import CLOSE_ICON_SVG from "../../../assets/icons/x.svg";

const MenuBar = ({ history, view }) => {
  const [activeView, setActiveView] = useState(view);
  const [displayMenu, setDisplayMenu] = useState(false);

  const navigateMenu = (path) => {
    setActiveView(path);
    history.push(path);
  };

  const handleDisplayMenu = () => {
    setDisplayMenu(!displayMenu);
  };

  return (
    <div
      className={`menu-container ${displayMenu ? "background-menu-bar" : ""}`}
    >
      <div className="logo-container">
        <img
          src={LOGO_PNG}
          className="logo"
          alt="aglocol"
          onClick={() => navigateMenu(ROOT)}
        />
      </div>
      <div className="menu-options-container">
        <div
          className={`menu-option ${activeView === ROOT ? "active-menu" : ""}`}
          onClick={() => navigateMenu(ROOT)}
        >
          Inicio
        </div>
        <div
          className={`menu-option ${
            activeView === ABOUT_US_PATH ? "active-menu" : ""
          }`}
          onClick={() => navigateMenu(ABOUT_US_PATH)}
        >
          Nuestra empresa
        </div>
        <div
          className={`menu-option ${
            activeView === SERVICES_PATH ? "active-menu" : ""
          }`}
          onClick={() => navigateMenu(SERVICES_PATH)}
        >
          Servicios
        </div>
        <div
          className={`menu-option ${
            activeView === PRODUCTS_PATH ? "active-menu" : ""
          }`}
          onClick={() => navigateMenu(PRODUCTS_PATH)}
        >
          Productos
        </div>
        <div
          className={`menu-option ${
            activeView === CONTACT_PATH ? "active-menu" : ""
          }`}
          onClick={() => navigateMenu(CONTACT_PATH)}
        >
          Donde comprar
        </div>
      </div>

      <img
        className={`mobile-menu-icon ${
          displayMenu ? "color-mobile-menu-icon" : ""
        }`}
        src={!displayMenu ? MENU_ICON_SVG : CLOSE_ICON_SVG}
        onClick={handleDisplayMenu}
        alt="menu"
      />
      {displayMenu ? (
        <div className="view-content mobile-menu-content">
          <div className="mobile-menu-options-container">
            <div
              className={`menu-option ${
                activeView === ROOT ? "active-menu" : ""
              }`}
              onClick={() => navigateMenu(ROOT)}
            >
              Inicio
            </div>
            <div
              className={`menu-option ${
                activeView === ABOUT_US_PATH ? "active-menu" : ""
              }`}
              onClick={() => navigateMenu(ABOUT_US_PATH)}
            >
              Nuestra empresa
            </div>
            <div
              className={`menu-option ${
                activeView === SERVICES_PATH ? "active-menu" : ""
              }`}
              onClick={() => navigateMenu(SERVICES_PATH)}
            >
              Servicios
            </div>
            <div
              className={`menu-option ${
                activeView === PRODUCTS_PATH ? "active-menu" : ""
              }`}
              onClick={() => navigateMenu(PRODUCTS_PATH)}
            >
              Productos
            </div>
            <div
              className={`menu-option ${
                activeView === CONTACT_PATH ? "active-menu" : ""
              }`}
              onClick={() => navigateMenu(CONTACT_PATH)}
            >
              Donde comprar
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default withRouter(MenuBar);
